import network from '@common/network/network';

const chunkSize = 10485760;
const maxRetries = 3;

const uploader = {
  async processFile(file, treeId, tagsData, progressCallback, reject, resolve) {
    file.isInProgress = true;

    let chunksCount = Math.ceil(file.size / chunkSize);
    if (chunksCount === 1) {
      await network.familyTreeLibrary
        .uploadFile({id: treeId, attachment: file, tags_data: JSON.stringify(tagsData)}, progressRes => {
          progressCallback((progressRes.loaded / progressRes.total) * 100);
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      return;
    }
    let oneChunkProgressContribution = 100 / chunksCount;
    const uploadInfo = {
      uploadId: null,
      asset_id: null,
      file_key: null,
      parts_info: [],
      retries: 0,
    };
    let error = false;

    for (let i = 0; i < chunksCount; i++) {
      if (error) {
        return reject('Error');
      }
      if (i > 0 && !uploadInfo.uploadId) {
        return reject('No fileID upload found.');
      }

      let start = i * chunkSize;
      let end = Math.min(file.size, start + chunkSize);
      let chunk = file.slice(start, end);
      const formData = this.getFormData(
        treeId,
        tagsData,
        chunk,
        file,
        i,
        chunksCount,
        uploadInfo.uploadId,
        uploadInfo.asset_id,
        uploadInfo.file_key,
        uploadInfo.parts_info
      );
      await this.uploadChunk(
        file,
        formData,
        oneChunkProgressContribution,
        i,
        uploadInfo,
        progressCallback,
        reject,
        resolve
      );
    }
  },
  async uploadChunk(
    file,
    formData,
    oneChunkProgressContribution,
    currentChunk,
    uploadInfo,
    progressCallback,
    reject,
    resolve
  ) {
    await network.familyTreeLibrary
      .uploadFilePart(formData, progressRes => {
        let currentChunkProgress = ((progressRes.loaded / progressRes.total) * 100).toFixed(2);
        progressCallback(
          currentChunk * oneChunkProgressContribution + (currentChunkProgress * oneChunkProgressContribution) / 100
        );
      })
      .then(response => {
        uploadInfo.uploadId = response.upload_id;
        uploadInfo.asset_id = response.asset_id;
        uploadInfo.file_key = response.file_key;
        uploadInfo.parts_info = response.parts_info;
        uploadInfo.retries = 0;
        if (formData.is_final) {
          return resolve(response.asset);
        }
      })
      .catch(error => {
        if (uploadInfo.retries < maxRetries) {
          uploadInfo.retries++;
          console.log('retrying', uploadInfo.retries);
          this.uploadChunk(
            file,
            formData,
            oneChunkProgressContribution,
            currentChunk,
            uploadInfo,
            progressCallback,
            reject,
            resolve
          );
        } else {
          return reject(error);
        }
      });
  },
  getFormData: function (treeId, tagsData, chunk, file, i, chunksCount, uploadId, asset_id, file_key, parts_info) {
    return {
      id: treeId,
      tags_data: JSON.stringify(tagsData),
      file_part: chunk,
      file_name: file.name,
      part_number: i + 1,
      is_final: i === chunksCount - 1,
      upload_id: uploadId,
      asset_id: asset_id,
      file_key: file_key,
      parts_info: JSON.stringify(parts_info),
      total_size: file.size,
    };
  },
};

export {uploader, chunkSize};
